import * as React from 'react';
import { DuaType } from '../../models/dua.model';
import Dua from './Dua';
import { Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface IDuasProps {
    duas: DuaType[];
    pinnedDuaIds: string[];
    onTogglePin: (id: string) => void;
}

const Duas: React.FunctionComponent<IDuasProps> = ({ duas, pinnedDuaIds, onTogglePin }) => {
    const { i18n } = useTranslation();
    const isPinned = (dua: DuaType): boolean => pinnedDuaIds.includes(`${dua.PartitionKey}${dua.RowKey}`);

    const sortByRowKey = (left: DuaType, right: DuaType): number => {
        return left.RowKey.localeCompare(right.RowKey, undefined, { numeric: true, sensitivity: 'base' });
    };

    const pinnedDuas = duas.filter(isPinned).sort(sortByRowKey);
    const unpinnedDuas = duas.filter((dua) => !isPinned(dua)).sort(sortByRowKey);

    const pinnedCategories = [...new Set(pinnedDuas.map(item => item.ta_Category))];
    const duaCategories = [...new Set(unpinnedDuas.map(item => item.ta_Category))];

    let accordionCounter: number = 0;
    const renderDua = (): React.JSX.Element[] => {
        const items: React.JSX.Element[] = [];

        if (pinnedDuas.length > 0) {
            items.push(
                <Accordion.Item key="pinned-duas" eventKey="pinned" id="pinned-duas" className="shadow p-1 mb-3 bg-body rounded border border-warning">
                    <Accordion.Header className="duatamil">Pinned</Accordion.Header>
                    <Accordion.Body>
                        {
                            pinnedCategories.map((category) => {
                                const categoryDuas = pinnedDuas.filter((dua) => dua.ta_Category === category);
                                const categoryTitle = i18n.language === "en" ? categoryDuas[0].en_Category : categoryDuas[0].ta_Category;

                                return (
                                    <div key={`pinned-${category}`} className="mb-3">
                                        <h6 className="duatamil">{categoryTitle}</h6>
                                        {
                                            categoryDuas.map((dua) => {
                                                return <Dua key={dua.PartitionKey + dua.RowKey} dua={dua} isPinned={true} onTogglePin={onTogglePin} />
                                            })
                                        }
                                    </div>
                                );
                            })
                        }
                    </Accordion.Body>
                </Accordion.Item>
            );
        }

        duaCategories.forEach((duaCategory) => {
            accordionCounter++;
            let subDuas: DuaType[];
            subDuas = unpinnedDuas.filter(
                subduas => subduas.ta_Category === duaCategory
            );

            items.push(<Accordion.Item key={subDuas[0].PartitionKey} eventKey={accordionCounter.toString()}  id={accordionCounter.toString()} className="shadow p-1 mb-3 bg-body rounded border border-info">
                <Accordion.Header id={subDuas[0].PartitionKey} className="duatamil">{accordionCounter.toString()}. {i18n.language === "en" ? subDuas[0].en_Category : subDuas[0].ta_Category}
                    <a id={"header" + subDuas[0].PartitionKey} href={"#" + subDuas[0].PartitionKey} className="hash-link" aria-label={"Direct link to " + duaCategory} title={"Direct link to " + duaCategory}></a>
                </Accordion.Header>
                <Accordion.Body>
                    {
                        subDuas.map(dua => {
                            return <Dua key={dua.PartitionKey + dua.RowKey} dua={dua} isPinned={isPinned(dua)} onTogglePin={onTogglePin} />
                        })
                    }
                </Accordion.Body>
            </Accordion.Item >);
        });

        return items;
    };
    return (
        <>
            {
                renderDua()
            }
        </>
    );
};
export default Duas;
